import React from 'react';
import { createPortal } from 'react-dom';
import { useDocument } from '../hooks/useDocument.js';
import { useUniqueId } from '../utils/unique-id.js';
const PORTAL_ROOT = 'headlessui-portal-root';
export const Portal = ({ children, idPrefix = '' }) => {
    var _a;
    const { document } = useDocument();
    const uniqueId = useUniqueId(idPrefix || 'portal');
    if (!(document === null || document === void 0 ? void 0 : document.body)) {
        return null;
    }
    return createPortal(React.createElement("div", { "data-portal-id": uniqueId, className: "isolate" }, children), (_a = getPortalRootElement(document)) !== null && _a !== void 0 ? _a : document.body);
};
const getPortalRootElement = (document) => {
    const root = document.getElementById(PORTAL_ROOT);
    if (root) {
        return root;
    }
    const newRoot = document.createElement('div');
    newRoot.setAttribute('id', PORTAL_ROOT);
    document.body.appendChild(newRoot);
    return newRoot;
};
//# sourceMappingURL=Portal.js.map